module.exports = __webpack_public_path__ + "static/media/OpenSans-BoldItalic.3a811373.ttf";